<template>
  <div id="pageAlerts">
    <v-container fill-heightfluid>
      <v-card :loading="loadingAlerts">
        <v-list  v-if="alertList.data && alertList.data.length" three-line>
          <v-list-item-group
          v-model="selected"
            active-class="primary--text"
            multiple
          >
            <template v-for="(alert, index) in alertList.data">
            <v-list-item :key="alert.title+index" @click="updateViewedState">
                  <v-list-item-avatar v-if="alert.message.avatar" class="avatar-container" size="30px">
                    <img :src="alert.message.avatar">
                  </v-list-item-avatar>

                  <v-list-item-avatar v-else>
                    <v-icon>fa-user-circle</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content class="align-center">
                      <v-list-item-title v-text="alert.title"></v-list-item-title>
                     <span class="text--darken-1 grey--text body-2 mt-2">{{alert.message.message}}</span>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-icon
                      v-if="!alert.viewed"
                      color="primary"
                      class="mb-2"
                    >
                      new_releases
                    </v-icon>
                    <v-list-item-action-text>{{getTimeAgo(alert.created_at)}}</v-list-item-action-text>

                  </v-list-item-action>
              </v-list-item>

              <v-divider
                  v-if="index + 1 < alertList.data.length"
                  :key="index"
              ></v-divider>
            </template>
          </v-list-item-group>
        </v-list>
        <v-alert v-else
          outlined
          type="info"
        >
          Nenhuma notificação encontrada para esse usuário
        </v-alert>
      </v-card>

      <div class="text-center" v-if="pageAtual < pageLast && pageCount < pageTotalItems">
        <v-btn class="ma-5"
          outlined
          color="white"
          :loading="loadMoreLoading"
          @click="userAlertsList(pageAtual+1)"
        >
          Carregar mais
        </v-btn>
      </div>
    </v-container>
  </div>
</template>
    
<script>
import Vue from 'vue'
import appApi from '../../plugins/api'
import AppPagination from '../../components/Pagination'
import moment from 'moment'

export default {
  components: {
    'app-pagination' : AppPagination
  },

  created() {
    this.id_usuario = this.$auth.user().id
  },

  mounted() {
    window.scrollTo(0,0)
    let page = 1
    this.userAlertsList(page)

  },

  data: () => ({
    selected: [],
    id_usuario: '',
    alertList: [],
    pageAtual: 1,
    pageCount: 0,
    pageLast: 0,
    pageTotalItems: 0,
    loadMoreLoading: false,
    loadingAlerts: false
  }),

  methods: {
    userAlertsList(page) {
      const data = {
        page : page && !isNaN(page) ? page : 1
      }

      this.loadMoreLoading = true
      this.loadingAlerts = true

      appApi.getUserAlerts(data)
      .then(result => {
        this.pageCount = result.data.data.length
        this.pageLast = result.data.pagination.lastPage
        this.pageTotalItems = result.data.pagination.total
        if (this.alertList.length <= 0) {
          this.alertList = result.data
        } else {
          this.alertList.data = this.alertList.data.concat(result.data.data)
        }
        
        this.pageAtual = result.data.pagination.page
        this.loadMoreLoading = false
        this.loadingAlerts = false
        this.getSelectedAlerts(this.alertList)
      })
      .catch(error => {
        console.log('error', error)
      });
    },

    getSelectedAlerts(alertList) {
      let list = alertList.data
      
      list.forEach(this.changeSelectedIems);
    },

    changeSelectedIems(item, index, array) {
      if(!item.viewed) {
        this.selected.push(index)
      }
    },

    updateViewedState() {
      appApi.putUserAlerts()
        .then(result => {
          this.getSelectedAlerts(this.alertList);
          this.$store.state.alerts = 0
          this.$router.push({name: 'ExplorerAccess'})
        })
        .catch(error => {
          console.log('error', error)
        });
    },

    getTimeAgo(value) {
      moment.locale("pt-br");
      return moment(value, "YYYY-MM-DD HH:mm:ss").fromNow();
    }
  }
}
</script>


<style lang="scss" scoped>
  .v-avatar.v-list-item__avatar, .v-list-item__action {
    align-self: center !important;
    align-items: center !important;
  }
</style>